export default "__VITE_ASSET__CqpeIgEG__"